const TESTIMONIALS = [
  {
    quote: "I haven't felt this calm in weeks.",
    name: "Sound healing client",
    role: "After a session",
  },
  {
    quote: "I was able to process some grief — it was a positive experience.",
    name: "Art therapy client",
    role: "After a session",
  },
  {
    quote: "I woke up feeling energetic like never before.",
    name: "Sound healing client",
    role: "The next morning",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="wynn-testimonials"
      className="relative border-t border-[#F4F1EC]/10"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="text-[11px] uppercase tracking-[0.32em] text-[#F4F1EC]/55 font-body mb-14">
          From the sessions
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} data-testid={`wynn-testimonial-${i + 1}`} className="flex flex-col">
              <p className="font-display text-[22px] md:text-[24px] italic font-light leading-[1.45] text-[#F4F1EC]">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-7 pt-5 border-t border-[#F4F1EC]/10">
                <div className="font-body text-sm text-[#F4F1EC]">{t.name}</div>
                <div className="font-body text-xs text-[#F4F1EC]/50 mt-1 uppercase tracking-[0.14em]">
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-12 font-body text-xs text-[#F4F1EC]/40">
          From real in-person sound healing &amp; art therapy sessions — the work that
          became WYNN.
        </p>
      </div>
    </section>
  );
}
